import {
	comMapping
} from '../../../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		formlist: [{
			prop: "fangcbh",
			label: "房产编号",
			isnotnull: true,
			type: "input",
		}, {
			prop: "fangcmc",
			label: "房产名称",
			type: "input",
		}, {
			prop: "nsrlx",
			label: "纳税人类型",
			isnotnull: true,
			type: "select",
		}, {
			prop: "suoyqNsrsbh",
			label: "所有权人纳税人识别号 (统一社会信用代码)",
			type: "input",
		}, {
			prop: "fangwzldzXian",
			label: "",
			slot: true,
			type: "select",
		}, {
			prop: "fangwzldzXx",
			label: "房屋坐落详细地址",
			isnotnull: true,
			type: "input",
		}, {
			prop: "fangcqdsj",
			label: "房产取得时间",
			isnotnull: true,
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "congjpkbz",
			label: "从价批扣标志",
			type: "select",
			selectval: [{
				value: '0',
				label: '是',
			}, {
				value: '1',
				label: '否',
			}]
		}, {
			prop: "dailrysfzlx",
			label: "代理人员身份证件类型",
			type: "select",
			selectval: comMapping.$cztds,
		}, {
			prop: "dailrmc",
			label: "代理人名称",
			type: "input",
		}, {
			prop: "shoulrq",
			label: "受理日期",
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "nsywYxqq",
			label: "纳税义务有效期起",
			type: "date",
			isdate: true,
			isnotnull: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "cqzhlx",
			label: "产权证号类型",
			type: "select",
		}, {
			prop: "bdcdwdm",
			label: "不动产单位代码",
			type: "input",
		}, {
			prop: "chuzfcmj",
			label: "出租面积",
			isnotnull: true,
			type: "input",
		}, {
			prop: "fangwsztdbh",
			label: "房屋所在土地编号",
			type: "input",
		}, {
			prop: "budcqzh",
			label: "不动产权证号",
			type: "input",
		}, {
			prop: "fangcyt",
			label: "房屋用途",
			isnotnull: true,
			type: "select",
		}, {
			prop: "suoyqMc",
			label: "所有权名称",
			type: "input",
		}, {
			prop: "fangwzldzXiangz",
			label: "房屋坐落地址(所处街乡)",
			isnotnull: true,
			type: "select",
		}, {
			prop: "fangczgsws",
			label: "房屋所属税务所(科，分局)",
			isnotnull: true,
			type: "input",
		}, {
			prop: "jianzmj",
			label: "建筑面积",
			isnotnull: true,
			type: "input",
		}, {
			prop: "congzpkbz",
			label: "从租批扣标志",
			type: "select",
			selectval: [{
				value: '0',
				label: '是',
			}, {
				value: '1',
				label: '否',
			}]
		}, {
			prop: "dailrsfzhm",
			label: "代理人身份证件号码",
			type: "input",
		}, {
			prop: "shoulr",
			label: "受理人",
			type: "input",
		}, {
			prop: "shoulswjg",
			label: "受理税务机关",
			type: "input",
		}, {
			prop: "nsywYxqz",
			label: "纳税义务有效期止",
			type: "date",
			isdate: true,
			disabled: true,
			isnotnull: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "fangcyz",
			label: "房产原值",
			type: "input",
			isnotnull: true,
		}, {
			prop: "chuzfcyz",
			label: "出租房产原值",
			type: "input",
			isnotnull: true,
		}, {
			prop: "jisbl",
			label: "计税比例",
			isnotnull: true,
			type: "input",
		}, {
			prop: "bgsj",
			label: "变更时间",
			isnotnull: true,
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}, ],
		formdata: {
			bgsj: "",
			jisbl: '',
			chuzfcyz: '',
			fangcyz: '',
			nsywYxqz: '',
			nsywYxqq: '',
			cqzhlx: '',
			bdcdwdm: '',
			fangcyz: '',
			congjpkbz: '',
			congzpkbz: '',
			dailrysfzlx: '',
			dailrsfzhm: '',
			dailrmc: '',
			shoulr: '',
			shoulrq: '',
			shoulswjg: '',
			fangcbh: '',
			fangwsztdbh: '',
			fangcmc: '',
			budcqzh: '',
			nsrlx: '',
			fangcyt: '',
			suoyqNsrsbh: '',
			suoyqMc: '',
			fangwzldzXian: '',
			fangwzldzXiangz: '',
			fangwzldzXx: '',
			fangczgsws: '',
			fangcqdsj: '',
			jianzmj: '',
		},
		headData: [{
				title: "选择",
				prop: "choose",
				width: "50",
				custom: true
			},
			{
				title: "房产编号",
				prop: "fangcbh",
				width: "80",
				custom: true
			}, {
				title: "纳税义务有效期起",
				prop: "nsywYxqq",
				width: "120",
			}, {
				title: "纳税义务有效期止",
				prop: "nsywYxqz",
				width: "120",
			},
			{
				title: "房屋所在土地编号",
				prop: "fangwsztdbh",
				width: "120"
			},
			{
				title: "房产名称",
				prop: "fangcmc",
				width: 160,
				align: "left"
			},
			{
				title: "不动产权证号",
				prop: "budcqzh",
				width: 160,
				align: "left"
			},
			{
				title: "建筑面积",
				prop: "jianzmj",
				width: 80,
				AmountFormat: true,
				align: "right"
			}, {
				title: "状态",
				prop: "caijFlag",
				width: "120",
				custom: true,
				align: "right"
			},
			{
				title: "操作",
				prop: "cz",
				width: "120",
				custom: true,
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}